import { Component } from '@angular/core';
import { AlertController, LoadingController } from 'ionic-angular';
import { User } from '../../providers/user';

/*
  Generated class for the AccountPasswordForm component.

  See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
  for more info on Angular 2 Components.
*/
@Component({
  selector: 'account-password-form',
  templateUrl: 'account-password-form.html'
})
export class AccountPasswordFormComponent {

  login: { password?: string } = {
    password: ''
  };
  
  submitted = false;

  constructor(
    public user: User,
    public loading: LoadingController,
    public alert: AlertController
  ) {}

  onModify(form) {
    let loader = this.loading.create({
      content: 'Please wait..',
      duration: 10000
    });
    this.submitted = true;
    if (form.valid) {
      loader.present().then(() => {
        this.user.profile().updatePassword(this.login.password).then(() => {
          loader.dismiss().then(() => {
            this.showAlert('Success', 'Your password has been changed.');
          });
        }, (e) => {
          loader.dismiss().then(() => {
            console.error(e);
            this.errorHandler(e);
          });
        });
      });
    }
  }

  showAlert(title, subtitle) {
    let alert = this.alert.create({
      title: title,
      subTitle: subtitle,
      buttons: ['OK']
    });
    return alert.present();
  }

  errorHandler(error) {
    let errorCode = error.code;
    let errorMessage = error.message;
    let handler = User.errorHandler(errorCode, errorMessage);
    this.showAlert(handler.title, handler.message);
  }
}


// WEBPACK FOOTER //
// ./src/components/account-password-form/account-password-form.ts